import styles from '../Carousel.module.scss';
import { LeftArrow } from '../../../../../lib/icons/LeftArrow';
import { RightArrow } from '../../../../../lib/icons/RightArrow';
import WithDevice from '../../../../common/WithDevice/WithDevice';
import { classes } from '../../../../../lib/utils/cssUtils';

const CarouselNavigation = () => {
  const prevClass = classes('prev-arrow', styles.navigationArrow);
  const nextClass = classes('next-arrow', styles.navigationArrow);

  return (
    <WithDevice desktop>
      <fieldset className={styles.navigation}>
        <legend style={{ display: 'none' }}>Carousel navigation</legend>
        <span role="button" className={prevClass}>
          <LeftArrow />
        </span>
        <div aria-live="polite" className={`${styles.swiperNavBullets} swiper-bullet-container`} />
        <span role="button" className={nextClass}>
          <RightArrow />
        </span>
      </fieldset>
    </WithDevice>
  );
};

export default CarouselNavigation;
